import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api from '../services/api';
import { neutral, radius, shadow, gradient, hero } from '../theme/tokens';
import HeroPattern from '../components/HeroPattern';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', values);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      // 还在用初始密码/临时密码的，先改密再进系统
      if (data.user?.mustChangePwd) {
        message.info('请先设置新密码');
        window.location.href = '/change-password?forced=1';
        return;
      }
      message.success('登录成功');
      window.location.href = '/';
    } catch (err: any) {
      message.error(err.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 24,
        position: 'relative',
        overflow: 'hidden',
        background: gradient.hero,
      }}
    >
      {/* 成长主题金色暗纹 */}
      <HeroPattern opacity={1.3} />

      <div
        className="fade-in-up"
        style={{
          width: '100%',
          maxWidth: 420,
          background: neutral[0],
          borderRadius: radius.xl,
          boxShadow: shadow.lg,
          padding: '40px 36px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src="/school-badge.gif"
            alt="中关村外国语学校校徽"
            style={{
              width: 76,
              height: 76,
              margin: '0 auto 16px',
              display: 'block',
              objectFit: 'contain',
            }}
          />
          <h1 style={{ fontSize: 22, margin: 0, color: neutral[800], fontWeight: 600 }}>
            中关村外国语学校
          </h1>
          <p style={{ color: neutral[500], marginTop: 6, fontSize: 14 }}>
            初中部学生成长发展指导平台
          </p>
        </div>

        <Form onFinish={onFinish} size="large">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined style={{ color: neutral[400] }} />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: neutral[400] }} />}
              placeholder="密码"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48, fontSize: 16, fontWeight: 500 }}
            >
              登 录
            </Button>
          </Form.Item>
        </Form>

        <p style={{ textAlign: 'center', color: neutral[400], fontSize: 12, marginTop: 20, marginBottom: 0 }}>
          忘记密码请联系班主任重置
        </p>
        <p style={{ textAlign: 'center', color: neutral[400], fontSize: 12, marginTop: 8, marginBottom: 0 }}>
          记录每一步成长 · 看见更好的自己
        </p>
      </div>
    </div>
  );
};

export default Login;
